export class Storage {
  /**
   * 获取缓存
   * @param {String} key  key
   * @param {String} def  若想要无缓存时，返回默认值则get('key','默认值')
   */
  static get(key, def = "") {
    // 获取缓存
    const timeout = parseInt(localStorage.getItem(`${key}__separator__`) || 0);
    // 过期失效
    if (timeout) {
      if (Date.now() > timeout) {
        this.remove(key);
        return;
      }
    }
    let value = null;
    try {
      value = JSON.parse(localStorage.getItem(key));
      //兼容判断 老版本的格式 {data: {}, validTime: 1604646386903}
      if (value.data && value.validTime) {
        value = JSON.parse(value.data);
      }
    } catch (err) {
      value = localStorage.getItem(key);
    }
    return value || def;
  }
  static set(key, value, timeout = 0) {
    /**
     * 设置缓存
     * @param {String} key   key
     * @param {Any} value   value
     * @param {Number} timeout  过期时间（单位：分钟）不设置时间即为永久保存
     */
    let _timeout = parseInt(timeout);
    let _string = Object.prototype.toString.call(value).toLowerCase();
    let val =
      _string === "[object object]" || _string === "[object array]"
        ? JSON.stringify(value)
        : value;
    localStorage.setItem(key, val);
    if (_timeout) {
      localStorage.setItem(
        `${key}__separator__`,
        Date.now() + 1000 * 60 * _timeout
      );
    } else {
      localStorage.removeItem(`${key}__separator__`);
    }
    return value;
  }
  static remove(key) {
    /**
     * 删除缓存 支持批量删除
     * @param {String | Array} key  key
     */
    if (Array.isArray(key)) {
      for (let k of key) {
        localStorage.removeItem(k);
        localStorage.removeItem(`${k}__separator__`);
      }
    } else {
      localStorage.removeItem(key);
      localStorage.removeItem(`${key}__separator__`);
    }
    return;
  }
  static clear() {
    //清除所有localStorage
    localStorage.clear();
  }
}
